export const CREATE_DMX_DEVICE_PRESET = 'CREATE_DMX_DEVICE_PRESET';
export const CREATE_DMX_DEVICE_PRESET_SUCCESSFUL = 'CREATE_DMX_DEVICE_PRESET_SUCCESSFUL';
export const CREATE_DMX_DEVICE_PRESET_FAILED = 'CREATE_DMX_DEVICE_PRESET_FAILED';
